/* eslint-disable */

import { rootApi } from '../rootApi';

export const dealerAddressBrandApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerAddressBrand: builder.query({
            query: (params) => {
                // Base parameters with filter options
                const queryParams = {
                    PageNumber: params.PageNumber !== undefined ? params.PageNumber : 1,
                    PageSize: params.PageSize || 10,
                    dealerId: params.dealerId > 0 ? params.dealerId : undefined, // ✅
                    brandId: params.brandId > 0 ? params.brandId : undefined, // ✅
                    contractStartDate: params.contractStartDate || null,
                    contractEndDate: params.contractEndDate || null
                };

                // Remove null values to avoid sending unnecessary data
                Object.keys(queryParams).forEach((key) => {
                    if (queryParams[key] === null || queryParams[key] === undefined) {
                        delete queryParams[key];
                    }
                });

                return {
                    url: 'v1/dealeraddressbrand/getlist',
                    method: 'POST',
                    body: queryParams
                };
            },
            transformResponse: (response) => {
                console.log('🔍 Transform Response:', response);

                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.items)) {
                        console.log('✅ Extracted data array with', response.data.items.length, 'items');
                        return response.data;
                    }

                    if (Array.isArray(response)) {
                        console.log('✅ Response is already an array with', response.length, 'items');
                        return { items: response, totalCount: response.length };
                    }
                }

                console.warn('⚠️ Response structure not as expected, returning empty');
                return { items: [], totalCount: 0 };
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 dealeraddressbrand/getlist query started with:', arg);
                try {
                    const result = await queryFulfilled;
                    console.log('✅ dealeraddressbrand/getlist query fulfilled:', result);
                } catch (error) {
                    console.error('❌ dealeraddressbrand/getlist query failed:', error);
                }
            },
            providesTags: ['DealerAddressBrand']
        }),

        getByIdDealerAddressBrand: builder.query({
            query: (id) => {
                return {
                    url: 'v1/dealeraddressbrand/getbyid',
                    method: 'GET',
                    params: {
                        id: id
                    }
                };
            },

            // Extract data array from the nested response structure
            transformResponse: (response) => {
                // Eğer response.data bir object ise, onu döndür
                if (response && typeof response === 'object' && response.data) {
                    return response.data; // ✅ Senin istediğin veri bu
                }

                // Fallback: boş nesne
                return {};
            },

            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: (result, error, id) => [{ type: 'DealerAddressBrand', id }]
        }),
        createDealerAddressBrand: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrand/save',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['DealerAddressBrand']
        }),

        updateDealerAddressBrand: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/dealeraddressbrand/update',
                    method: 'POST',

                    body: data
                };
            },
            invalidatesTags: ['DealerAddressBrand']
        })
    })
});

export const { useGetAllDealerAddressBrandQuery, useCreateDealerAddressBrandMutation, useUpdateDealerAddressBrandMutation, useGetByIdDealerAddressBrandQuery } = dealerAddressBrandApi;
